import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Modal, Row, Spinner} from "react-bootstrap";
import FlowrateChartGroup from "../../Components/FlowrateChartGroup/FlowrateChartGroup";
import {textFilter} from "react-bootstrap-table2-filter";
import DataTable from "../../Components/Beverages/StepReportTable/DataTable";
import RangeIndicator from "../../Components/RangeIndicator/RangeIndicator";
import {FaArrowLeft} from "react-icons/all";
import Badge from "react-bootstrap/Badge";
import AlertsModal from "./AlertsModal";
import {formatDateTime, removeFractionDigits, turnAlertsIntoObjectArray} from "../../General/general";
import SensorCharts from "./SensorCharts";
import "./ObjectDetailsPage.css"
import {IoMdArrowDropdown, IoMdArrowDropup} from "react-icons/io";

export default function ObjectDetailsPage({
                                              beveragesLineService,
                                              setMoreDetailsButtonClicked,
                                              selectedRow,
                                              healthFormatter,
                                              selectedProductionLineId,
                                              alertsColumns
                                          }) {
    const [sensorCharts, setSensorCharts] = useState([]);
    const [sensorChartsUnitSymbol, setSensorChartsUnitSymbol] = useState(null);
    const [sensorResponse, setSensorResponse] = useState([]);
    const largeFilterStyle = {width: 300, margin: '0 auto', height: 30, fontSize: 12}
    const filterStyle = {margin: '0 auto', height: 30, fontSize: 12}
    const smallFilterStyle = {width: 100, margin: '0 auto', height: 30, fontSize: 12}
    const headerStyle = {fontSize: 15, border: 'none'}
    const colStyle = {fontSize: 15, fontWeight: 'bold', background: 'white', verticalAlign: 'center'}
    const [showModal, setShowModal] = useState(false);
    const [showChartModal, setShowChartModal] = useState(false);
    const [lineDetails, setLineDetails] = useState([]);
    const [lineDetailsPreRinseMerged, setLineDetailsPreRinseMerged] = useState([]);
    const [showPreRinseMerged, setShowPreRinseMerged] = useState(true);
    const [preRinseCount, setPreRinseCount] = useState(0);
    const [alertsData, setAlertsData] = useState([]);
    const [isStepAlertsRequestInProgress, setIsStepAlertsRequestInProgress] = useState(false);
    const [isObjectDetailsRequestInProgress, setIsObjectDetailsRequestInProgress] = useState(false);
    const [verticalLineTimeStamps, setVerticalLineTimeStamps] = useState([]);

    const getStepAlerts = async (lineId, stepGroupId, selectedProductionLineId) => {
        try {
            setAlertsData([]);
            setIsStepAlertsRequestInProgress(true);
            const response = await beveragesLineService.getStepGroupAlerts(lineId, stepGroupId, selectedProductionLineId);
            setIsStepAlertsRequestInProgress(false);
            setAlertsData(response.data);
        } catch (error) {
            setIsStepAlertsRequestInProgress(false);
            console.error(error);
        }

    }

    const volumeFormatter = (cell, row) => {
        if (!row.minVolume || !row.maxVolume || (!showPreRinseMerged  && preRinseCount > 0 && row.stepGroup === 'Pre Rinse')) {
            return cell ? (cell / 1000).toFixed(2) : null;
        }
        const minVolume = row.minVolume === 0 ? 0 : parseFloat((row.minVolume / 1000).toFixed(2));
        const volume = cell === 0 ? 0 : parseFloat((cell / 1000).toFixed(2));
        const maxVolume = row.maxVolume === 0 ? 0 : parseFloat((row.maxVolume / 1000).toFixed(2));
        return <div className={'pl-5 pr-5'}>
            <RangeIndicator minValue={minVolume} value={volume} maxValue={maxVolume}/>
        </div>
    }

    const cubicMeterFormatter = (cell) => {
        return cell === 0 ? 0 : (cell / 1000).toFixed(1);
    }

    const tableDurationFormatter = (cell, row) => {
        if (!row.minDuration || !row.maxDuration || (!showPreRinseMerged && preRinseCount > 0 && row.stepGroup === 'Pre Rinse')) {
            return <div style={{opacity: 0.7}} className='p-3'>{removeFractionDigits(cell / 60)}</div>
        }
        const minDuration = removeFractionDigits(row.minDuration / 60);
        const duration = removeFractionDigits(cell / 60);
        const maxDuration = removeFractionDigits(row.maxDuration / 60);
        return <div className={'pl-5 pr-5'}>
            <RangeIndicator minValue={minDuration} value={duration} maxValue={maxDuration}/>
        </div>

    }
    const alertsFormatter = (cell, row) => {
        if (cell > 0) {
            return <div className='justify-content-center align-items-center'>
                <div className={'d-inline-block'}>
                    {cell}
                </div>
                {showPreRinseMerged && preRinseCount > 0 && row.stepGroup === 'Pre Rinse' ? null :
                    <div className={'d-inline-block'}>
                        <Button style={{height: '24.5px'}} className='pl-1 pr-0 pt-0 pb-0' onClick={async () => {
                            await getStepAlerts(selectedRow.id, row.id, selectedProductionLineId);
                            setShowModal(true);
                        }} size={'sm'} variant={'link'}><h6><Badge pill variant={"danger"}> i</Badge></h6>
                        </Button>
                    </div>
                }
            </div>
        } else {
            return 0;
        }
    }

    const stepGroupFormatter = (() => {
        const preRinseEncountered = new Set();

        return (cell, row) => {
            if (cell === 'Pre Rinse') {
                if (!preRinseEncountered.has(cell) && preRinseCount > 0) {
                    preRinseEncountered.add(cell);
                    return (
                        <Button style={{color: '#212529'}} className='p-0' variant='link'
                                onClick={() => setShowPreRinseMerged(!showPreRinseMerged)}>
                            <div style={{display: 'inline-block'}}>
                                {showPreRinseMerged ? <IoMdArrowDropdown/> : <IoMdArrowDropup/>}
                            </div>
                            <div style={{display: 'inline-block', fontWeight: 'bold', fontSize: '15px'}}>
                                {cell}
                            </div>
                        </Button>
                    );
                } else {
                    return <div>{cell}</div>;
                }
            }
            return cell;
        };
    })();

    const handleShow = () => setShowChartModal(true);
    const handleClose = () => setShowChartModal(false);

    const columns = [
        {
            dataField: 'id',
            title: 'ID',
            hidden: true
        },
        {
            dataField: 'stepGroup',
            title: 'Step Group',
            sort: true,
            filter: textFilter({style: filterStyle}),
            formatter: stepGroupFormatter
        },
        {
            dataField: 'solution',
            title: 'Solution',
            sort: true,
            filter: textFilter({style: filterStyle})
        },
        {
            dataField: 'startTime',
            title: 'Start Time [HH:mm:ss]',
            sort: true, formatter: formatDateTime,
            filter: textFilter({style: filterStyle})
        },
        {
            dataField: 'recycledVolume',
            title: 'Recycled Volume [\u33A5]',
            formatter: cubicMeterFormatter,
            sort: true,
            filter: textFilter({style: filterStyle})
        },
        {
            dataField: 'drainedVolume',
            title: 'Drained Volume [\u33A5]',
            formatter: cubicMeterFormatter,
            sort: true,
            filter: textFilter({style: filterStyle})
        },
        {
            dataField: 'volume',
            sort: true,
            title: `Volume [\u33A5]`,
            formatter: volumeFormatter,
            filter: textFilter({style: largeFilterStyle})
        },
        {
            dataField: 'duration',
            sort: true,
            title: 'Duration [Minutes]',
            formatter: tableDurationFormatter,
            filter: textFilter({style: largeFilterStyle})
        },
        {
            dataField: 'alerts',
            sort: true,
            title: 'Alerts',
            formatter: alertsFormatter,
            filter: textFilter({style: smallFilterStyle})
        },
        {
            dataField: 'health',
            title: 'Score',
            formatter: healthFormatter,
            sort: true,
            filter: textFilter({style: filterStyle})
        }];

    const calculateRecuperatedWater = (selectedRow) => {
        if (!selectedRow.recuperatedVolume || !selectedRow.freshWaterVolume) {
            return 0;
        }
        return ((selectedRow.recuperatedVolume / (selectedRow.freshWaterVolume)) * 100).toFixed(2);
    }

    const covertFreshWaterLitersToCubicMeters = (selectedRow) => {
        return (selectedRow.kpi1 / 1000).toFixed(1);
    }

    const handleStepGroupDisplayInfo = (selectedRow) => {
        return selectedRow.isActive ? selectedRow.stepGroup : 'Done';
    }

    const addAlertMarkers = (data, alertTimestamps) => {
        let newData;
        let alertTimesArray = alertTimestamps;
        newData = data.map((obj, index) => {
            let timeSeriesNewArray = [];
            timeSeriesNewArray = obj.timeSeriesData.map((timeObj, index) => {
                let indexFound = alertTimesArray?.indexOf(timeObj?.x);
                if (indexFound !== -1 && obj.name === 'Alerts') {
                    return {
                        ...timeObj,
                        marker: {symbol: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAABOCAYAAAA3vqZVAAAAAXNSR0IArs4c6QAABYFJREFUaEPtl2tIlFkYx89zzutcbBxbV8t2Xahsl4woY8XCDFZqpVhltrQEYT8Eu1psRmEUuAVDsNGFiMDEjVrtRjR+kJEoCslK1ClcWjL31gfdbrPMrrpeRp2Z95xnmWlncHLeuWhDX15hPvm+z+/8/+c5z/+8QN7RH7wjLokJjIQAqarSkNHR1+8tXEhISgqSwUEPmM0iFhERwVhRkeArODQEfOXKrWg01tOJCUYAUGi1iGlpY2Rw0JQgxM9EqxVQWemJZgFhwVhVpeUFBedIf/97xOHIJi9epOOjRxTGx33vocFAMD0dISeHk2XLJogs10tdXd/B2bMR4YpgtFgM3On8EdvbvwSrldKBAe+z/l+QKCQEMTWViOJiD0lN3Z8wZ84PYDZPhlMeEowWC5Ndrl9IY+Ni+uCBBGNjvhqoUMlfBA0GFGvzPHLp1t91L19mh9v3IDAiAmltXe5xOq/Ta9cywGoF8r+tXqaSPUEL0uuRl5cjFhc7NMnJi6CgIKTyYLDFouHJyeuxpcUKzc0SffUK/EUjdeHU53DBAhQlJTKWln6bYDA0Qk7OtD0Pqufq6FhORkZOsEOHCml3N/XbGwnq3wEv3P8sz85GUVs7wbKyellKSh4AyFN3KlATzWbKy8v7eFPTB6y2llG73ac2WuibcJGRQXhNjWDFxU6WkZESFixKSlzy4cOSdOsWgZERXzPNFIxGIxFlZUirqwW123VQUKCg2GJhmJnplqurKevqIuByzQ6s1xOxbh2yo0cFDA9HAC9a5Jb37qXs4UMCbvfswDodEfn5yI4f5zA8rFdWbDZTNJk8ck0NZffuERgfnx04MZGIoiJB9+8foaOjaWHBoqxsXD55UiM1NxMYGJhVc+G8ecgrKzndsuUn9vTpWti2jYfuakQQPT0VcmfnKXbkiI4+ezY78JIlXN6166YmN3cb5OVNvDn0ggdIW5vk6u1dLF2+/Cu12WZ1jjEnR6a5uR9BXd1foSbttNOCZrPEnzyZhBs3WKz77D9+KEkEN23yMJ1OD01NQRb7FzEd7A2IsbG/oaFhLm1vj8luP1hkZiKWlLikvj5D1GDfmLx4cY7o7f2XHDsmhQuHNy30g3lhocDNm20JO3fmg0KoKcYi2u1OceCAhk5ORgyKoIAAQDx40MMYSwKz2a2UyYpgnph4ndy8+Tmtr6fIue+5SLEIAIRnZQmyfftjyen8NOo8nro6bGuT+PPnf8COHQv9mRwO7P0fMoZiz55RKSkpLZzasNvnTSuxdOnX5Pz5WnL3rgQeT8hGCwQJABHp6dyzYcPH+kuX+iJd+MJf9iwWxnt6voI7d85BRwcLlVaBI+S99qxf75Q0mrlKnRxycimtEM1mnXA4RsiFCxI4nUGqpywEyerVHJKTP4Tbtx2R1EZ1UnyWr1r1Aq5cSSdNTYCIgSYLqDUakXzxxZ/06tXFSscn7MhUVN3QoCNa7RDu3q3FgQHvgQncOr0gUVjoFkJ8pmlttUWjNirFvoHiVZ2fP0TOnEmClhZA/noK+jqZUiQm00na3HwACIn6Mybqmw1aLBoxOvqY7Nv3ifdzxgdmDLnJNCnZ7e9DV9e0BAqnPmqwT7nVukWcPm0h9+9T4Bxw/nzkGzfu1TQ2no7WYsWQCFcAOzsrhM12AurqktCb10VFbrZihT7WL8Wo9zhwdW1rk4jNloQ22z/C4QCxZs03mlOnzseqNmawz27vTaWlxY1uN2e9vcZIozGmkIikQO7vv8S6u7+H0tLfIj37VsFe1QCBtJwRO6aunhFB4SUV/DbdDFtLtVq1Om4OqM0VN2tndNmLx2rUPY6HqyFrqlarVsfNAbW54matOqvV5lKbK24OqM0VN2vVyaU2l9pccXPgPx4Qb22HevBVAAAAAElFTkSuQmCC)'},
                        enabled: true,
                        radius: 4,
                        zIndex: 5
                    }
                } else {
                    return timeObj;
                }
            })
            return {...obj, timeSeriesData: timeSeriesNewArray};
        })
        return newData;
    }

    const getMetersFlowRateData = async (selectedProductionLineId, selectedObjectId, startDate, endDate) => {
        try {
            await getVerticalLineTimeStamps(selectedProductionLineId, selectedRow.id, startDate, endDate);
            const alertTimeStamps = await getAlertTimeStamps(selectedProductionLineId, selectedRow.id, startDate, endDate);
            const response = await beveragesLineService.getGroupedMetersFlowRateData(selectedProductionLineId, selectedRow.line, startDate, endDate);
            let group3Sensors = response.data.find(obj => obj?.group === "3");
            group3Sensors.sensors.push({
                'name': 'Alerts',
                'label': 'Alerts',
                'unitSymbol': '\u2113/hour',
                'unitLabel': 'litres per HOUR',
                'minVal': 0,
                'maxVal': 0,
                'tags': [],
                'timeSeriesData': alertTimeStamps.map((alertTimeStamp) => [alertTimeStamp, 0.0])
            });
            let modifiedSensors = addAlertMarkers(turnAlertsIntoObjectArray(group3Sensors.sensors), alertTimeStamps);
            setSensorCharts(modifiedSensors.map(sensor => ({
                name: sensor.label,
                data: sensor.timeSeriesData,
                tags: sensor.tags
            })));

            response.data = response.data.map(obj =>
                obj.group === "3" ? {...group3Sensors, sensors: modifiedSensors} : obj
            );
            setSensorResponse(response.data);
            setSensorChartsUnitSymbol(group3Sensors.sensors[0]?.unitSymbol);
        } catch (error) {
            console.error(error);
        }
    };

    const getVerticalLineTimeStamps = async (selectedProductionLineId, selectedObjectId, startDate, endDate) => {
        try {
            const response = await beveragesLineService.getVerticalLineData(selectedProductionLineId, selectedObjectId, startDate, endDate);
            setVerticalLineTimeStamps(response.data.lineTimestamps);
            return response.data.lineTimestamps
        } catch (error) {
            console.error(error);
            return [];
        }

    };


    const getAlertTimeStamps = async (selectedProductionLineId, selectedObjectId, startDate, endDate) => {
        try {
            const response = await beveragesLineService.getAlertsTimestampsData(selectedProductionLineId, selectedObjectId, startDate, endDate);
            return response.data.lineTimestamps
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const getObjectDetails = async (objectId, selectedProductionLineId) => {
        try {
            setIsObjectDetailsRequestInProgress(true);
            const response = await beveragesLineService.getObjectDetails(objectId, selectedProductionLineId);
            setIsObjectDetailsRequestInProgress(false);
            setLineDetails(response.data);
            let preRinseMergedData = response.data.reduce((acc, obj, index) => {
                if (obj.stepGroup === 'Pre Rinse') {
                    if (index === 0) {
                        acc.push({...obj, healthCount: 1});
                    } else {
                        let preRinsedMergedObj = acc.find(item => item.stepGroup === 'Pre Rinse');
                        if (preRinsedMergedObj) {
                            setPreRinseCount(prevCount => prevCount + 1);
                            preRinsedMergedObj.solution += ' + ' + obj.solution;
                            preRinsedMergedObj.recycledVolume += obj.recycledVolume;
                            preRinsedMergedObj.drainedVolume += obj.drainedVolume;
                            preRinsedMergedObj.volume += obj.volume;
                            preRinsedMergedObj.duration += obj.duration;
                            preRinsedMergedObj.alerts += obj.alerts;
                            preRinsedMergedObj.health += obj.health;
                            preRinsedMergedObj.healthCount += 1;
                        }
                    }
                } else {
                    acc.push(obj);
                }
                return acc;
            }, []);
            preRinseMergedData = preRinseMergedData.map(obj => {
                if (obj.stepGroup === 'Pre Rinse' && obj.healthCount) {
                    obj.health = Math.round(obj.health / obj.healthCount);
                    delete obj.healthCount;
                }
                return obj;
            });
            setLineDetailsPreRinseMerged(preRinseMergedData);
        } catch (error) {
            setIsObjectDetailsRequestInProgress(false);
            console.error(error);
        }
    }

    const durationFormatter = (minutes) => {
        let days = Math.floor(minutes / 1440);
        let remainingMinutes = minutes % 1440;
        let hours = Math.floor(remainingMinutes / 60);
        let mins = remainingMinutes % 60;
        let daysStr = days > 0 ? String(days) + "d " : "";
        let hoursStr = String(hours).padStart(2, '0');
        let minsStr = String(mins).padStart(2, '0');
        return daysStr + hoursStr + ':' + minsStr;
    }


    useEffect(() => {
        getObjectDetails(selectedRow.id, selectedProductionLineId);
        getMetersFlowRateData(selectedProductionLineId, selectedRow.id, selectedRow.startTime, selectedRow.endTime);
    }, [])

    return (<Card style={{backgroundColor: '#f5f7fb'}} bsPrefix={'main-card-style'}>
        <Modal show={showChartModal} onHide={handleClose} dialogClassName="modal-size"
               aria-labelledby="example-custom-modal-styling-title">
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={{offset: 2}}>
                        <SensorCharts
                            sensorData={sensorResponse}
                            showSpinnerOnLoad={true}
                            yAxisTitle="Flowrate"
                            tooltipFormatter={null}
                            multipleYAxis={false}
                            isModal={true}
                            verticalLineTimestamps={verticalLineTimeStamps}
                        />
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
        <AlertsModal
            isAlertsRequestInProgress={isStepAlertsRequestInProgress}
            alertsData={alertsData}
            show={showModal}
            setShow={setShowModal}
            alertsColumns={alertsColumns}
        />
        <Card.Body className={'p-0'}>
            <Button variant={"link"} onClick={() => setMoreDetailsButtonClicked(false)}><FaArrowLeft
                style={{color: 'black', position: 'absolute', left: 20, top: 70}} size={20}/></Button>
            <Row>
                <Col md={5} style={{paddingLeft: '35px'}}>
                    <Card>
                        <Card.Body className={'pl-3 pr-3 pt-2 pb-2'}>
                            <Row className={'pb-3 pt-3'}>
                                <Col>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Object
                                    </div>
                                    <div>
                                        <h5 className={'mt-2'} style={{
                                            fontWeight: 'bold',
                                            textAlign: 'center'
                                        }}>{selectedRow.objectName}</h5>
                                    </div>
                                </Col>
                                <Col>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Start Time
                                    </div>
                                    <div>
                                        <h5 className={'mt-2'} style={{
                                            fontWeight: 'bold',
                                            textAlign: 'center'
                                        }}>{selectedRow.startTimeFormatted}</h5>
                                    </div>
                                </Col>
                                <Col>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Duration [HH:mm]
                                    </div>
                                    <div>
                                        <h5 className={'ml-2 mt-2'} style={{
                                            fontWeight: 'bold',
                                            textAlign: 'center'
                                        }}>{durationFormatter(selectedRow.duration)}</h5>
                                    </div>
                                </Col>
                            </Row>
                            <hr/>
                            <Row className={'pt-4 pb-3'}>
                                <Col>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Recipe
                                    </div>
                                    <div>
                                        <div className={'mt-2'} style={{
                                            fontWeight: 'bold',
                                            whiteSpace: 'nowrap'
                                        }}>{selectedRow.recipe}</div>
                                    </div>
                                </Col>
                                <Col>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Total Fresh Water [<h5 style={{display: 'inline-block'}}>&#13221;</h5>]
                                    </div>
                                    <div>
                                        <h5 className={'mt-4'} style={{
                                            fontWeight: 'bold',
                                            textAlign: 'center'
                                        }}>{covertFreshWaterLitersToCubicMeters(selectedRow).toLocaleString()} </h5>
                                    </div>
                                </Col>
                                <Col>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Health Score
                                    </div>
                                    <div>
                                        <div className={'mt-2'}
                                             style={{fontWeight: 'bold'}}>{healthFormatter(selectedRow.health)}</div>
                                    </div>
                                </Col>
                            </Row>
                            <hr/>
                            <Row style={{paddingBottom: '9px'}}>
                                <Col className={'mt-3'}>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Percentage Recuperated
                                    </div>
                                    <div>
                                        <h5 className={'mt-4'} style={{
                                            fontWeight: 'bold',
                                            textAlign: 'center'
                                        }}>{calculateRecuperatedWater(selectedRow).toLocaleString()}%</h5>
                                    </div>
                                </Col>
                                <Col className={'mt-3'}>
                                    <div style={{
                                        color: "grey",
                                        whiteSpace: 'nowrap',
                                        fontWeight: 800,
                                        textAlign: 'center'
                                    }}>
                                        Current Step Group
                                    </div>
                                    <div>
                                        <h5 className={'mt-4'} style={{
                                            fontWeight: 'bold',
                                            textAlign: 'center'
                                        }}>{handleStepGroupDisplayInfo(selectedRow)}</h5>
                                    </div>
                                </Col>
                                <Col className={'mt-3'}>
                                    <div style={{color: "grey", fontWeight: 800, textAlign: 'center'}}>
                                        Alerts Found
                                    </div>
                                    <div>
                                        <h5 className={'mt-4'}
                                            style={{fontWeight: 'bold', textAlign: 'center'}}>{selectedRow.alerts}</h5>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={7}>
                    <Card>
                        <Card.Body className={'p-2'}>
                            <Row>
                                <Col md={{offset: 9}}>
                                    <Button onClick={() => handleShow()}>View all charts</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {sensorChartsUnitSymbol ?
                                        <FlowrateChartGroup showLegend linked charts={sensorCharts}
                                                            unitSymbol={sensorChartsUnitSymbol} yAxisTitle={"Flowrate"}
                                                            verticalLineTimestamps={verticalLineTimeStamps}
                                                            showSpinnerOnLoad plotlines={true}/> :
                                        <Spinner animation={"border"} variant={'primary'}/>}

                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className={'pt-2'}>
                <Col>
                    {!isObjectDetailsRequestInProgress ? <DataTable
                        headerStyle={headerStyle}
                        colStyle={colStyle}
                        data={showPreRinseMerged && preRinseCount > 0 ? lineDetailsPreRinseMerged : lineDetails}
                        columns={columns}
                        pageSize={lineDetails.length > 5 ? 4 : 5}
                        paginationSize={10}
                    /> : <Spinner animation='border' variant='primary'/>}

                </Col>
            </Row>
        </Card.Body>
    </Card>)
}
